<script lang="ts">
  import { initWikiCategories } from './services'
  import { onMount } from 'svelte'
  
  import WikiCategoriesNoItemsBanner from './components/WikiCategoriesNoItemsBanner/WikiCategoriesNoItemsBanner.svelte'
  import WikiCategoriesLoader from './components/WikiCategoriesLoader/WikiCategoriesLoader.svelte'
  import WikiCategoriesItems from './components/WikiCategoriesItems/WikiCategoriesItems.svelte'
  import WikiBranches from './components/WikiBranches/WikiBranches.svelte'
  import GeneralLayout from '../../layouts/GeneralLayout.svelte'

  onMount(initWikiCategories)
</script>

<GeneralLayout>
  <WikiBranches />
  <WikiCategoriesItems />
  <WikiCategoriesLoader />
  <WikiCategoriesNoItemsBanner />
</GeneralLayout>